import { cn } from "@omni/utils/styles";

import { BlockSection } from "@/components/General/BlockSection/blockSection.container";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const Registered = ({ className }: Props) => {
    const { t } = useGranite();

    return (
        <BlockSection
            className={cn(className)}
            title={
                <>
                    {t("checkout.transportServiceRegistered.title")}{" "}
                    <i className={"las la-check la-2x"} />
                </>
            }
            iconClass={"las la-truck la-4x"}
        >
            <p>{t("checkout.transportServiceRegistered.description")}</p>
            <ul className="text-left my-0 p-0">
                <li>{t("checkout.transportServiceRegistered.identityCard")}</li>
                <li>
                    {t("checkout.transportServiceRegistered.driversLicense")}
                </li>
                <li>{t("checkout.transportServiceRegistered.warrant")}</li>
            </ul>
        </BlockSection>
    );
};
